import { useStore } from "@store/index"

export const useArticlesCollection = (subtopicId: string) => {
  const { expertInsightsStore } = useStore()
  return expertInsightsStore.articlesStore.getCollection(subtopicId)
}

export default useArticlesCollection
